import React from 'react';

// Icons are imported with `?url` (not referenced as runtime `/icons/*.png` strings) so the bundler
// emits them into the production build. The esbuild prod build only copies favicons out of public/,
// so a bare path would 404 in production even though Vite serves it fine in dev.
import iceUrl from '../../public/icons/ice-small.png?url';
import hevUrl from '../../public/icons/hev-small.png?url';
import phevUrl from '../../public/icons/phev-small.png?url';
import evUrl from '../../public/icons/ev-small.png?url';

// Maps the model `powertrain` enum (model/schemas/schemaModel.js) to its icon url.
const powertrainIcons = {
  ICE: iceUrl,
  MHEV: hevUrl,
  HEV: hevUrl,
  PHEV: phevUrl,
  EV: evUrl,
};

const powertrainLabels = {
  ICE: 'Gasoline / Diesel',
  MHEV: 'Mild hybrid',
  HEV: 'Hybrid',
  PHEV: 'Plug-in hybrid',
  EV: 'Electric',
  FCEV: 'Fuel cell',
  mixed: 'Mixed powertrains',
};

export default function BadgePowertrain({ powertrain, className = '' }) {
  if (!powertrain) {
    return null;
  }

  const title = `${powertrain} — ${powertrainLabels[powertrain] || powertrain}`;
  const iconUrl = powertrainIcons[powertrain];

  // FCEV and mixed have no icon — fall back to a text badge.
  if (!iconUrl) {
    return <span className={`badge badge-secondary ${className}`} title={title}>{powertrain}</span>;
  }

  return <img src={iconUrl}
    alt={powertrain}
    title={title}
    loading='lazy'
    decoding='async'
    className={`align-middle ${className}`}
    style={{ height: '20px', objectFit: 'contain' }} />;
}
